import { string } from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

const Wrapper = styled.div`
  display: block;
`;

const Input = styled.input``;

function CheckBox({ className, id, label, ...inputProps}) {
  const componentClass = classNames(
    className,
    'se-checkbox',
    'se-checkbox--md'
  );

  return (
    <Wrapper className={componentClass}>
      <Input type="checkbox" id={id} {...inputProps} />
      <label htmlFor={id}>
        <span className="se-checkbox-label">{label}</span>
      </label>
    </Wrapper>
  );
}

CheckBox.propTypes = {
  className: string,
  label: string.isRequired,
};

CheckBox.defaultProps = {
  className: '',
}

export default styled(CheckBox)``;